import { render, staticRenderFns } from "./jianjiwancheng.vue?vue&type=template&id=27ddd701&scoped=true"
import script from "./jianjiwancheng.vue?vue&type=script&lang=js"
export * from "./jianjiwancheng.vue?vue&type=script&lang=js"
import style0 from "./jianjiwancheng.vue?vue&type=style&index=0&id=27ddd701&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ddd701",
  null
  
)

export default component.exports